export const JOB_ACTION = {
  VIEW: 'View',
  DOWNLOAD_W9_DOCS: 'Download W9 Docs',
  DOWNLOAD_INVOICES: 'Download Invoices',
  DOWNLOAD_REPORTS: 'Download Reports',
  REINSTATE: 'Reinstate',
  DELETE: 'Delete'
};
